import type { NextPage } from 'next'
import styles from './selectInput.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faLock,
  faEnvelope,
  faUser,
  faPlus,
} from '@fortawesome/free-solid-svg-icons'


library.add(faLock, faEnvelope, faUser, faPlus)

interface Props {
  placeholder?: string
  onChange: any
  icon?: any
  type: string
  color?: string
  label?: string
  smallPadding?: boolean
  required?: boolean
  disabled?: boolean
  isSelect?: boolean
  multiple?: boolean
  options: {
    value: string
    label: string
    checked: boolean
  }[]
}

export type SelectOption<T> = {
  label: string,
  value: T,
  checked: boolean
}
const SelectInputComponent: NextPage<Props> = (props: Props) => {

  if (props.isSelect) {
    return (
      <div >
        {props.label && <div className={styles.label}>{(props.required ? "* " : "") + props.label}</div>}

        <div className={styles.select_input}>
          {props.icon && (
            <div className={styles.icon_wrapper}>
              <FontAwesomeIcon
                className={styles.icon}
                icon={['fas', props.icon]}
              />
            </div>
          )}

          <select
            disabled={props.disabled}
            className={styles.select}
            onChange={(e) => {
              props.onChange(e.target.value)
            }}
          >
            {props.options.map((o, i) =>
              <option key={i} value={o.value}>{o.label}</option>
            )}
          </select>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      {props.label && <div className={styles.label}>{(props.required ? "* " : "") + props.label}</div>}

      <div className={styles.check_input}>
        {props.icon && (
          <div className={styles.icon_wrapper}>
            <FontAwesomeIcon
              className={styles.icon}
              icon={['fas', props.icon]}
            />
          </div>
        )}

        {props.options.map((o, i) =>
          <label key={i}>
            <input
              type="checkbox"
              checked={o.checked}
              onChange={() => {
                if (props.multiple) {
                  let optionsTemp = [...props.options];
                  optionsTemp[i].checked = !o.checked
                  // setOptionsChecked(optionsCheckedTemp)
                  props.onChange(optionsTemp)
                } else {
                  props.onChange(props.options[i].value)
                }
              }}
            />
            {o.label}
          </label>

        )}

        {/*         
        <input
            disabled={props.disabled}
            value={value}
            type={props.type}
            placeholder={props.placeholder}
            className={textInputClassName}
            style={{ backgroundColor: props.color }}
            onChange={(e) => {
              props.onChange(e.target.value)
              setValue(e.target.value)
            }
            }
          /> */}

      </div>
    </div>
  )
}

export default SelectInputComponent
